<template>
  <app-view-default-template class="app-view-default-template-sitemap">

    <app-content-title label="Sitemap"></app-content-title>

    <div v-for="item in links" :key="item.name">
      <p><strong>{{ item.meta.title }}</strong><br>
        <a :href="getRoutePath(item.name)" v-on:click.prevent="goToRouteName(item.name)">
          {{ getUrl(item.name) }}
        </a>
      </p>
    </div>

  </app-view-default-template>
</template>

<script>
  import AppViewDefaultTemplate from '@/components/layout/templates/view/AppViewTemplateDefault';
  import AppContentTitle from '@/components/ui/titles/AppContentTitle';
  import {mixinRoutesHandler} from '@/mixins/routes-handler';

  export default {
    name: 'Sitemap',

    mixins: [mixinRoutesHandler],

    components: {
      AppViewDefaultTemplate, AppContentTitle,
    },

    data: function () {
      return {
        links: [],
      }
    },

    methods: {
      getRoutePath(routeName) {
        return this._mixinGetRoutePath(routeName);
      },

      goToRouteName(routeName) {
        this._mixinGoToRouteName(routeName);
      },

      getUrl(routeName) {
        return window.location.origin + this.getRoutePath(routeName);
      },

      setLinks() {
        this.links = this._mixinRoutesHandler_getRoutesAVisibleIn('sitemap');
      },
    },

    mounted() {
      this.setLinks();
    }
  }
</script>

<style lang="scss">
  .app-view-default-template-sitemap {
    background-color: white;
    min-height: calc(100vh - 100px);

    a {
      font-weight: normal;
    }
  }
</style>
